import { render, staticRenderFns } from "./SpaceIcon.vue?vue&type=template&id=765a1c3c"
import script from "./SpaceIcon.vue?vue&type=script&lang=js"
export * from "./SpaceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports